<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      :loading="isLoading || !isUserLoaded"
      :default-tab="defaultTab">
    <template v-slot:tabItem>
      <lot-template-general-info
          v-if="showGeneralInfo"
          :lot-template="lotTemplate"
          :loading="isLoading"
          :positions="positions"
          @change="initialize" />
    </template>
  </tab-list>
</template>

<script>
  import TabList from '@/components/reused/ui/TabList.vue'
  import LotTemplateGeneralInfo from '@/components/pages/shared/LotTemplate/LotTemplateGeneralInfo.vue'
  import lotMixin from '@/utils/mixins/scoped/lotMixin'
  import { LOT_TEMPLATE_TABS_ENUM } from '@/constants/enums'
  import { LOT_TABS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import {
    LOT_TEMPLATE_MANAGEMENT,
    POSITIONS_TEMPLATE_MANAGEMENT,
    CURRENT_USER
  } from '@/constants/store.js'

  export default {
    components: {
      TabList,
      LotTemplateGeneralInfo
    },
    mixins: [lotMixin],
    props: {
      lotTemplateId: {
        type: String,
        required: true
      },
      lotType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        LOT_TEMPLATE_TABS_ENUM,
        isLoading: false,
        currentTab: LOT_TABS.GENERAL_INFO,
        defaultTab: LOT_TABS.GENERAL_INFO
      }
    },
    computed: {
      ...mapState(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        currentLotTemplate: state => (state[LOT_TEMPLATE_MANAGEMENT.STATE.CURRENT_TEMPLATE])
      }),
      ...mapState(CURRENT_USER.NAMESPACE, {
        contactPerson: state => (state[CURRENT_USER.STATE.CONTACT_PERSON] || null)
      }),
      ...mapState(POSITIONS_TEMPLATE_MANAGEMENT.NAMESPACE, {
        positions: state => (state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.POSITIONS_TEMPLATE_LIST] || [])
      }),
      title () {
        return this.$t('Просмотр шаблона')
      },
      tabs () {
        const tabs = { ...LOT_TEMPLATE_TABS_ENUM }
        return tabs
      },
      showGeneralInfo () {
        return this.currentTab === LOT_TABS.GENERAL_INFO
      },
      lotTemplate () {
        return this.currentLotTemplate || {
          lotTemplateId: this.lotTemplateId,
          lotType: this.lotType
        }
      },
      isUserLoaded () {
        return !!this.contactPerson
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.lotTemplateId) {
          return
        }
        vm.initialize()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        getLotTemplateInfoAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.GET_LOT_TEMPLATE,
        clearLotTemplateInfoAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_LOT_TEMPLATE
      }),
      ...mapActions(POSITIONS_TEMPLATE_MANAGEMENT.NAMESPACE, {
        getPositionsListAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.GET_POSITION_TEMPLATE_LIST,
        clearPositionsListAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_POSITION_TEMPLATE_LIST
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotTemplateInfoAction(),
            this.clearPositionsListAction()
          ])
      },
      initialize: async function () {
        const model = {
          lotTemplateId: this.lotTemplateId,
          lotType: this.lotType
        }
        try {
          this.isLoading = true
          await Promise.all([
            this.getLotTemplateInfoAction(model),
            this.getPositionsListAction(model)
          ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
